// extracted by mini-css-extract-plugin
export default {"label":"EmployedsFilterLabel_label__YuzkE","smallLabel":"EmployedsFilterLabel_smallLabel__Wszyv"};